// Banner Slider
var bannerSwiper = new Swiper('.banner--slider', {
    // Optional parameters
    slidesPerView: 'auto',
    observer: true,
    watchOverflow: true,
    speed: 300,

    autoplay: {
        delay: 6000,
    },

    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },

    // // If we need pagination
    // pagination: {
    //     el: '.swiper-pagination',
    //     clickable: 'true'
    // },
    //
    // // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    //
    // // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // },
 })

 // Image Carousel
 var carouselSwiper = new Swiper('.b-images--carousel', {
     // Optional parameters
    slidesPerView: 'auto',
    observer: true,
    watchOverflow: true,
    loop: true,
    // If we need pagination
    // pagination: {
    //     el: '.swiper-pagination',
    //     clickable: 'true'
    // },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
  })

// Product Gallery
 var productSwiper = new Swiper(".productSwiperAll", {
         spaceBetween: 10,
         slidesPerView: 4,
         freeMode: true,
         watchSlidesProgress: true,
 });

 var productSwiper2 = new Swiper(".productSwiperExtended", {
     zoom: true,
     spaceBetween: 10,
     navigation: {
         nextEl: ".swiper-button-next",
         prevEl: ".swiper-button-prev",
     },
     thumbs: {
         swiper: productSwiper,
     },
 });

 // var zoomOptions = {
 //     width: 600,
 //     height: 400,
 //     zoomWidth: 400,
 //     offset: {
 //         vertical: 0, horizontal: 10
 //     }
 // };
 // new ImageZoom(document.getElementById("zoom-image"), zoomOptions);
